"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAuthentication = void 0;
const UserGroups_1 = require("./UserGroups");
class UserAuthentication {
    /**
     * Checks all `UserGroups` and identifies whether he is a `SalesModeUser`.
     */
    static isSalesModeUser(userGroups) {
        return userGroups.indexOf(UserGroups_1.UserGroups.SalesmodeUser) !== -1 &&
            userGroups.indexOf(UserGroups_1.UserGroups.PowermodeUser) === -1 &&
            userGroups.indexOf(UserGroups_1.UserGroups.IgusPowermodeUser) === -1
            ? true
            : false;
    }
    /**
     * Checks all `UserGroups` and identifies whether he is a `PowerModeUser`.
     */
    static isPowerModeUser(userGroups) {
        return userGroups.indexOf(UserGroups_1.UserGroups.PowermodeUser) > -1 || userGroups.indexOf(UserGroups_1.UserGroups.IgusPowermodeUser) > -1
            ? true
            : false;
    }
}
exports.UserAuthentication = UserAuthentication;
//# sourceMappingURL=UserAuthentication.js.map